// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2axGB","question":"Question_question__1k-s3","description":"Question_description__1Efsy"};